import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';

@Component({
  selector: 'app-ui-image',

  template: `
    <img
      [src]="src()"
      [alt]="alt()"
      [attr.width]="width()"
      [attr.height]="height()"
      [class]="cssClass()"
      loading="eager"
      decoding="async"
      (load)="onLoad($event)" />
  `,
  styles: [`:host { display: flex; width: 100%; height: 100%; min-width: 0; min-height: 0; align-items: center; justify-content: center; overflow: visible; }
    img { max-width: 100%; max-height: 100%; object-fit: contain; object-position: center; width: 100%; height: 100%; display: block; overflow: visible; }`],

  changeDetection:
    ChangeDetectionStrategy.OnPush
})
export class UiImageAtomComponent {
  readonly src =
    input.required<string>();

  readonly alt =
    input('');

  readonly width =
    input<number | null>(null);

  readonly height =
    input<number | null>(null);

  readonly cssClass =
    input('');

  // Dimensiones naturales de la imagen una vez cargada (permite saber su orientacion).
  readonly imageLoaded =
    output<{ width: number; height: number }>();

  protected onLoad(event: Event): void {
    const img = event.target as HTMLImageElement;
    this.imageLoaded.emit({ width: img.naturalWidth, height: img.naturalHeight });
  }
}
